// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__jMhjt","headingText":"styles_headingText__t41JQ","panel__section__background":"styles_panel__section__background__YMylk"};